import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.ComposeViewport
import cmp.shared.SharedApp
import cmp.shared.utils.initKoin
import demo.demoModule
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.koin.core.context.GlobalContext
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {

    initKoin {
        properties(
            mapOf(
                "SUPABASE_URL" to cmp.web.BuildConfig.SUPABASE_URL,
                "SUPABASE_ANON_KEY" to cmp.web.BuildConfig.SUPABASE_ANON_KEY,
                "HTTP_LOG_LEVEL" to "NONE",
            ),
        )
    }

    val isDemo = cmp.web.BuildConfig.APP_FLAVOR == "demo"
    if (isDemo) {
        GlobalContext.get().loadModules(listOf(demoModule), allowOverride = true)
    }

    val storedLanguage = localStorage.getItem("app_language")
    if (storedLanguage != null) {
        document.documentElement?.setAttribute("lang", storedLanguage)
    }

    val handleAppLocale: (String?) -> Unit = { languageTag ->
        if (languageTag != null) {
            localStorage.setItem("app_language", languageTag)
            document.documentElement?.setAttribute("lang", languageTag)
        } else {
            localStorage.removeItem("app_language")
            document.documentElement?.setAttribute("lang", window.navigator.language)
        }
    }

    onWasmReady {
        ComposeViewport(document.body!!) {
            var localeVersion by remember { mutableStateOf(0) }

            key(localeVersion) {
                if (isDemo) {
                    Column(modifier = Modifier.fillMaxSize()) {
                        DemoBanner(appUrl = "https://app.cauce.oddpods.studio")
                        SharedApp(
                            modifier = Modifier.weight(1f),
                            updateScreenCapture = {},
                            handleRecreate = { window.location.reload() },
                            handleThemeMode = {},
                            handleAppLocale = handleAppLocale,
                            onSplashScreenRemoved = {},
                        )
                    }
                } else {
                    SharedApp(
                        updateScreenCapture = {},
                        handleRecreate = { window.location.reload() },
                        handleThemeMode = {},
                        handleAppLocale = handleAppLocale,
                        onSplashScreenRemoved = {},
                    )
                }
            }
        }
    }
}
